import { TRANSLATION, Yup } from "@/imports-files/common/common";

export const REVIEW_EMAIL= {
                                    dummyTokens:  [   {text: "name.first", value: "{{name.first}}" },
                                                        { text: "name.last", value: "{{name.last}}" },
                                                        { text: "name.full", value: "{{name.full}}" },
                                                        { text: "email.home", value: "{{email.home}}" },
                                                        { text: "email.work", value: "{{email.work}}" }
                                                  ],

                                    texts:{
                                                close           :  'Close',
                                                email_body      :  'Email Body',
                                                edit_heading    :  'Edit Template',
                                                create_heading  :  'Create New Template',
                                                insert_token    :  'Insert token',
                                                save            :  'Save',
                                                cancel          :  'Cancel',
                                                reset           :  'Reset',
                                                subject         :  'Subject',
                                                tag_heading     :  'Data Tags',
                                                purpose         :   'Purpose',
                                                custom_purpose  :  'New Purpose'
                                          },   

                                    email_template:{
                                                            formInitialValue: {     
                                                                                    template:{
                                                                                                     master_template_id: '',
                                                                                                     master_template_type: '',
                                                                                                     subject     : '',
                                                                                                     email_body  : '',
                                                                                                     default     : false
                                                                                             }
                                                                              },

                                                            formValidation : Yup.object({
                                                                                                template: Yup.object({
                                                                                                                              master_template_id     :   Yup.string().required(TRANSLATION('common:errors:required')),
                                                                                                                              subject                :   Yup.string().required(TRANSLATION('common:errors:required')),
                                                                                                                              email_body             :   Yup.string().required(TRANSLATION('common:errors:required'))
                                                                                                                     })
                                                                                    })
                                                          }

                                   
                         }

                                       

                             export const CANDIDATE_DATE_INITIAL_VALUES = {
                              radioTabTest:   '',
                              start_date  :   '',
                              end_date    :   ''
                           };

